import React, { Component } from 'react';
import { Button, Drawer, Descriptions, Divider, Comment } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import ReactHtmlParser from 'react-html-parser';
import { isMobile } from 'react-device-detect';
import { checkPermission } from '../../utils/permission';
import { isValidDate, processHTML } from '../../utils/helpers';
import ScheduleJobForm from './ScheduleJobForm';

class ScheduleJobDetail extends Component {
    state = { isOpenForm: false };

    close = () => {
        this.props.onCancel();
        this.props.reloadList();
    };

    render() {
        const { visible, currentData } = this.props;
        return (
            <>
                <Drawer
                    visible={visible}
                    title="Chi tiết công việc"
                    onClose={this.close}
                    maskClosable={false}
                    width={isMobile ? '100%' : '50%'}
                    extra={checkPermission('schedule_jobs', 'update') ? (
                        <Button type="primary" icon={<EditOutlined />} onClick={() => this.setState({ isOpenForm: true })}>
                            Sửa
                        </Button>
                    ) : null}
                    footer={<div style={{ textAlign: 'right' }}><Button onClick={this.close}>Đóng</Button></div>}
                >
                    {visible ? (
                        <div>
                            <Descriptions size="small">
                                <Descriptions.Item label="Vai trò công việc">{currentData?.typejob_name}</Descriptions.Item>
                            </Descriptions>
                            <Divider className="no-margin" />
                            <Comment
                                className="comment-content-detail"
                                author={<span className="ant-descriptions-item-label">Mô tả công việc</span>}
                                content={<div className="chingo-content-detail">{ReactHtmlParser(processHTML(currentData?.description))}</div>}
                            />
                            <Divider className="no-margin" />
                            <Comment
                                className="comment-content-detail"
                                author={<span className="ant-descriptions-item-label">Ghi chú</span>}
                                content={ReactHtmlParser(currentData?.note || '')}
                            />
                            <Divider className="no-margin" />
                            <Descriptions size="small">
                                <Descriptions.Item label="Ngày tạo">
                                    {isValidDate(currentData?.created_at)} bởi {currentData?.created_user}
                                </Descriptions.Item>
                            </Descriptions>
                        </div>
                    ) : null}
                </Drawer>
                <ScheduleJobForm
                    visible={this.state.isOpenForm}
                    currentData={currentData}
                    reloadData={this.props.reloadData}
                    onCancel={() => this.setState({ isOpenForm: false })}
                />
            </>
        );
    }
}

export default ScheduleJobDetail;
